import type { ComponentProps } from "react"
import Separator from "@/v2-ui/separator"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipLink } from "@/v2-backoffice-client/components/link"
import InvitationResendButton from "@/v2-backoffice-client/invitation/resend/InvitationResendButton"
import InvitationRemoveButton from "@/v2-backoffice-client/invitation/remove/InvitationRemoveButton"
import InvitationUpdateButton from "@/v2-backoffice-client/invitation/update/InvitationUpdateButton"
import type { InvitationFragment } from "@/v2-backoffice-client/invitation/__types__/invitation.fragment"

export type InvitationViewToolbarProps = ComponentProps<"div"> & {
  invitation: InvitationFragment | null | undefined
}

function InvitationViewToolbar(props: InvitationViewToolbarProps) {
  const { invitation, ...viewSheetToolbarProps } = props
  if (!invitation) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <InvitationResendButton invitationId={invitation.Id} isStacked>
        Resend
      </InvitationResendButton>
      <TooltipLink
        to={`>>?v=tenant:${invitation.TenantId}`}
        variant="ghost"
        isStacked
        iconSrc="users"
        content="Open team"
      >
        Team
      </TooltipLink>
      {invitation.ConsumedByUser && (
        <TooltipLink
          to={`>>?v=user:${invitation.ConsumedByUser.Id}`}
          variant="ghost"
          isStacked
          iconSrc="user"
          content="Open the user account created from this invitation"
        >
          User
        </TooltipLink>
      )}
      <Separator orientation="vertical" />
      <InvitationUpdateButton invitation={invitation} isStacked>
        Update
      </InvitationUpdateButton>
      <Separator orientation="vertical" />
      <InvitationRemoveButton invitationId={invitation.Id} isStacked>
        Remove
      </InvitationRemoveButton>
    </ViewSheet.Toolbar>
  )
}

export default InvitationViewToolbar
